var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_68699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0895 7.41113C31.9684 8.29004 31.9684 9.71738 31.0895 10.5963L13.0895 28.5963C12.2105 29.4752 10.7832 29.4752 9.9043 28.5963L0.904297 19.5963C0.0253906 18.7174 0.0253906 17.29 0.904297 16.4111C1.7832 15.5322 3.21055 15.5322 4.08945 16.4111L11.5004 23.815L27.9113 7.41113C28.7902 6.53223 30.2176 6.53223 31.0965 7.41113H31.0895Z",
    fill: "#10B981"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_68699"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0H31.75V36H0.25V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.bd3376518203034a9e3498d69349be64.svg";
export { ForwardRef as ReactComponent };